<template>
  <div id="app" :style="appContainerStyle"  :class="{ 'offcanvas-open': openOffCanvas }">
      <cart-side-bar />
      <off-canvas :class="{ active: offCanvasActive }"  />
      <site-header />
      <router-view/>
      <scroll-to-top />
      <clear-stroage />
      <site-footer />
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex';
  import SiteHeader from '@/components/siteHeader/SiteHeader.vue';
  import OffCanvas from '@/components/menu/OffCanvas.vue';
  import ScrollToTop from '@/components/ScrollToTop.vue';
  import ClearStroage from '@/components/ClearStroage.vue';
  import CartSideBar from '@/components/checkout/CartSideBar.vue';
  import SiteFooter from '@/components/siteFooter/SiteFooter.vue';

  import { Probability } from './plugins/helpers';

  export default {
    metaInfo() {
      return {
        titleTemplate: `%s - ${this.$t('app.name')}`,
        title: '',
        meta: [
          { vmid: 'description', name: 'description', content: this.description },
          { vmid: 'keywords', name: 'keywords', content: this.keywords },
        ],
        bodyAttrs: { style: this.openOffCanvas ? 'overflow: hidden' : '' },
      };
    },
    mounted() {
      // this.$store.dispatch('loadTokenFromLocalStore');

      this.$store.dispatch('fetchFee');
      this.$store.dispatch('fetchSale');
      this.$store.dispatch('fetchNewArrival');
      this.$store.dispatch('fetchHot');
      this.$echo.channel('server').listen('.server.broadcasting', () => {
      });

      this.$store.dispatch('uaParse');
      if (this.isLogined) {
        this.$store.dispatch('getIdentity');
      }
      (new Probability({
        p: this.config.site_url || this.config.static_url ? '30%' : '100%',
        f: () => this.$store.dispatch('fetchConfigs'),
      }))();
      (new Probability({
        p: this.categories.length ? '30%' : '100%',
        f: () => this.$store.dispatch('fetchCategories'),
      }))();
    },
    computed: {
      ...mapState({
        config: state => state.config,
        categories: state => state.product.categories,
        openOffCanvas: state => state.app.openOffCanvas,
        offCanvasActive: state => state.app.offCanvasActive,
      }),
      ...mapGetters([
        'isLogined',
      ]),
      appContainerStyle() {
        return {
          overflow: this.offCanvasActive ? 'hidden' : 'visible',
        };
      },
      description() {
        return 'hello world!';
      },
      keywords() {
        return ['a', 'b', 'c'].join(', ');
      },
    },
    watch: {
      $route() {
        this.$store.dispatch('offCanvasClose');
      },
    },
    components: {
      OffCanvas,
      SiteHeader,
      ScrollToTop,
      CartSideBar,
      SiteFooter,
      ClearStroage,
    },
  };
</script>
<style lang="scss">
  body {
    div.modal-backdrop:nth-child(6) {
      z-index: 9191 !important;
    }
  }
</style>
